import { useFormContext } from 'react-hook-form';

import * as Form from 'components/_core/form';

import { BeneficiarySchemaWithEmail } from '../beneficiarySchema';
import locales from '../locales';

const EmailField = () => {
  const {
    formState: { errors },
    register,
  } = useFormContext<BeneficiarySchemaWithEmail>();

  return (
    <Form.Field
      error={errors.inviteeEmail?.message}
      label={locales.emailLabel}
      marginBottom="space-16"
      marginTop="space-32"
    >
      <Form.Input type="email" {...register('inviteeEmail')} />
    </Form.Field>
  );
};

export default EmailField;
